// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HiD7xY {
  font-family: var(--font-family-base);
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
}

.yDi0ND {
  background: #f9fafc;
  height: 74px;
  border-radius: 4px;
  padding: 8px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
}

.P5Rjdc {
  background: var(--color-card-active, #ffeee5);
  box-shadow: 0 2px 8px 0 rgba(214, 64, 0, 0.08);
}

.HPdQ7k {
  flex: 1;
}

.ibkKzk {
  font-weight: 600;
  font-size: 16px;
}

._77nldv {
  font-size: 14px;
  color: #666;
}

.l0ai0L {
  margin-right: 12px;
  accent-color: var(--color-primary, #d64000);
  width: 20px;
  height: 20px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-auth/src/components/AdvancedSelector/AdvancedSelector.module.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,6CAA6C;EAC7C,8CAA8C;AAChD;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,WAAW;EACX,YAAY;AACd","sourcesContent":[".advancedSelector {\n  font-family: var(--font-family-base);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.advancedSelectorOption {\n  background: #f9fafc;\n  height: 74px;\n  border-radius: 4px;\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  border: none;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.advancedSelectorOptionActive {\n  background: var(--color-card-active, #ffeee5);\n  box-shadow: 0 2px 8px 0 rgba(214, 64, 0, 0.08);\n}\n\n.advancedSelectorContainer {\n  flex: 1;\n}\n\n.advancedSelectorName {\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.advancedSelectorDescription {\n  font-size: 14px;\n  color: #666;\n}\n\n.radioInput {\n  margin-right: 12px;\n  accent-color: var(--color-primary, #d64000);\n  width: 20px;\n  height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"advancedSelector": `HiD7xY`,
	"advancedSelectorOption": `yDi0ND`,
	"advancedSelectorOptionActive": `P5Rjdc`,
	"advancedSelectorContainer": `HPdQ7k`,
	"advancedSelectorName": `ibkKzk`,
	"advancedSelectorDescription": `_77nldv`,
	"radioInput": `l0ai0L`
};
module.exports = ___CSS_LOADER_EXPORT___;
